export default __webpack_public_path__ + "static/media/guesty_step3.540501d3.png";